import locale from "csi/locale";
import { convertNamesStoreDataToComponentItems } from "csi/middleware/common";
import Names from "csi/store/Names";
import csiStore from "csi/store/_base";
import { ComponentItem } from "designSystem/types/component-item-types";
import { queryAggregateStore } from "src/c8-platform/service/aggregateStoreService";
import { IAggregateStoreParams, IAggregateStoreResponse } from "src/c8-platform/type/aggregateStore";

/** Get values from aggregate store as ComponentItem[] 
 * TODO: This will be deprecated in favor of getAggregateStoreResponseAsComponentItems
*/
export async function getAggregateStoreValuesAsComponentItems (aggregateStoreParams: IAggregateStoreParams): Promise<ComponentItem<any>[]> {
	const store = new Names({
		aggregateStoreParams,
		locale,
		request: csiStore.getAggregateStoreRequest(aggregateStoreParams),
	});
	
	const data = await store.asyncQuery();
	const options = convertNamesStoreDataToComponentItems(data, store);
	return options;
};

/** Get values from aggregate store as ComponentItem[] 
 * TODO: Once the conversion of aggregate store response to ComponentItem[] is complete, this will be the only method to use
*/
export async function getAggregateStoreResponseAsComponentItems (aggregateStoreParams: IAggregateStoreParams): Promise<IAggregateStoreResponse> {
	const data = await queryAggregateStore(aggregateStoreParams);
	return data;
};